import React from 'react';
import GcNavbar from '../../components/gcstudent/Navbar/GcNavbar';
import Footer from '../../components/gcstudent/footer/Footer';
import StudentDashboardLayout from '../../layouts/gcstudent/studentdashboardLayout/StudentDashboardLayout';

const GcStudentMasterLayout = ({ children }) => {
    return (
        <>

            <GcNavbar />
            {children}
            <Footer/>
        </>
    );
};

export default GcStudentMasterLayout;